import type { FieldValidator } from 'final-form'

export const composeValidators =
	(...validators: FieldValidator<any>[]) =>
	(value: any, allValues: object) =>
		validators.reduce((error, validator) => error || validator(value, allValues), undefined)
